import React from 'react';
import PropTypes from 'prop-types';
import BaseIcon from 'assets/icons/BaseIcon';

class ChevronUp extends BaseIcon {
    render() {
        const {
            height,
            width,
            style,
        } = this.props;

        return (
            <svg
                height={ height }
                style={ style }
                viewBox='0 0 515.556 515.556'
                width={ width }
                xmlns='http://www.w3.org/2000/svg'
            >
                <path d='M257.778 128.885l257.778 257.778H386.67L257.778 257.774 128.892 386.671 0 386.663z' />
            </svg>
        );
    }
}

ChevronUp.defaultProps = {
    height: '512',
    width: '512',
};

ChevronUp.propTypes = {
    height: PropTypes.string,
    width: PropTypes.string,
    style: PropTypes.object,
};

export default ChevronUp;



// WEBPACK FOOTER //
// ./src/assets/icons/ChevronUp.js